import Ellipsis from 'ellipsis.js';

const ELLIP = '…';
const RM = 'Read More';
const ELM_TYPE = 1; // Node.ELEMENT_NODE
const TEXT_TYPE = 3; // Node.TEXT_NODE

const emptyNode = node => {
  if (node.nodeType === ELM_TYPE) {
    return node.textContent.trim() === '';
  }
  if (node.nodeType === TEXT_TYPE) {
    return node.nodeValue && node.nodeValue.trim() === '';
  }
  return false;
};

const replaceEndingReadMoreWithAnchor = ({
  element,
  ellipsis,
}) => {
  let pos = element.childNodes.length - 1;
  let lastChild = element.childNodes[pos];
  while (pos >= 0 && lastChild && emptyNode(lastChild)) {
    pos -= 1;
    lastChild = element.childNodes[pos];
  }
  if (pos < 0 || !lastChild) {
    return;
  }
  if (lastChild.nodeType !== TEXT_TYPE) {
    // eslint-disable-next-line prefer-destructuring
    lastChild = lastChild.childNodes[0];
  }
  const nodeText = lastChild.nodeValue;
  if (nodeText.lastIndexOf(ellipsis) + ellipsis.length === nodeText.length) {
    lastChild.nodeValue = nodeText.slice(0, nodeText.length - RM.length);
  }
};

// Monkey patch to get Ellipsis.js to support a linked `Read More` anchor after
// the ellipsis character
export default function EllipsisReadMore(props) {
  // add extra characters in if it's the default value
  if (props.ellipsis === ELLIP || !props.ellipsis) {
    props.ellipsis = `${ELLIP} ${RM}`;
  }
  const { ellipsis } = props;
  const that = Ellipsis(props);

  const originalSimpleText = that.simpleText.bind(that);
  that.simpleText = element => {
    originalSimpleText(element);
    replaceEndingReadMoreWithAnchor({ element, ellipsis });
  };

  const originalHandleChildren = that.handleChildren.bind(that);
  that.handleChildren = element => {
    originalHandleChildren(element);
    replaceEndingReadMoreWithAnchor({ element, ellipsis });
  };

  return that;
}
